import client from '../api-client';
import { getBaseAccessesUrlByNetwork } from './getBaseUrlByNetwork';
import networkConnectionNormalizer from '../../normalizers/networkConnection';

export default async function updateConnection({ APIBaseURL, updates, network, resourceId }) {
  const baseURl = getBaseAccessesUrlByNetwork(APIBaseURL, network.type);
  const url = `${baseURl}/${resourceId}`;

  const normalizerFunc = networkConnectionNormalizer(network);

  try {
    const response = await client(url, { body: updates, method: 'PATCH' });

    return { updatedConnection: normalizerFunc(response) };
  } catch ({ message }) {
    return { error: { message } };
  }
}
